// src/components/dashboard/departmentadmin/DepartmentDashboardView.js
// The department admin's cards+charts, extracted so Company Admin's
// drilldown can reuse the exact same fetch logic and rendering by passing
// a departmentIdOverride instead of relying on the viewer's own session.
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import StatTile from './StatTile';
import MessageBoardWidget from '../MessageBoardWidget';
import ParticipantTrendChart from './ParticipantTrendChart';
import TrainingHoursChart from './TrainingHoursChart';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function DepartmentDashboardView({ departmentIdOverride }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/stat/get_department_dashboard_stats.php`, {
          params: departmentIdOverride ? { department_id: departmentIdOverride } : {},
          withCredentials: true
        });
        if (isMounted) setStats(response.data);
      } catch (error) {
        console.error('Error fetching department dashboard stats:', error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStats();
    return () => { isMounted = false; };
  }, [departmentIdOverride]);

  return (
    <>
      <Row className="g-3 mb-1">
        <Col md={3}>
          <StatTile title="Upcoming Trainings" icon="bi-calendar-event" value={stats?.upcomingTrainingsCount ?? 0} loading={loading} />
        </Col>
        <Col md={3}>
          <StatTile title="Employees Assigned" icon="bi-people" value={stats?.employeesAssignedCount ?? 0} loading={loading} />
        </Col>
        <Col md={3}>
          <StatTile title="Pending Requests" icon="bi-hourglass-split" value={stats?.pendingRequestsCount ?? 0} loading={loading} />
        </Col>
        <Col md={3}>
          <StatTile title="Certificates This Month" icon="bi-award" value={stats?.certificatesThisMonthCount ?? 0} loading={loading} />
        </Col>
        {/* Personal to the viewing session — only on the department admin's
            own dashboard, not when a company admin drills into this
            department's view. */}
        {!departmentIdOverride && (
          <Col md={3}>
            <MessageBoardWidget />
          </Col>
        )}
      </Row>
      <Row className="g-3 mt-1">
        <Col md={6}>
          <ParticipantTrendChart data={stats?.participantTrend ?? []} loading={loading} />
        </Col>
        <Col md={6}>
          <TrainingHoursChart data={stats?.trainingHours ?? []} loading={loading} />
        </Col>
      </Row>
    </>
  );
}

export default DepartmentDashboardView;
